const sentryService = require('../../third-party/sentry/services/sentryService.js');
const firebaseService = require('../../third-party/firebase/services/firebaseService.js');

export const initiateReporting =()=>{
    sentryService.initiateSentry()
}

export const captureMessage=(message)=>{
    sentryService.captureMessage(message);
}

export const captureEvent=({event, params})=>{
    try{
        firebaseService.captureEvent({event:event, params:params})
    }catch(ex){
        sentryService.captureEvent("Failed to capture event", ex)
    }
}


export const captureException=(message, error)=>{
    sentryService.captureEvent(message, error)
}



// WEBPACK FOOTER //
// ./src/utils/reporting/reportingService.js